import React from 'react';
import { motion } from 'framer-motion';
const CART_LINK = 'https://creaycrecepro.shop/checkouts/cn/hWNAWLippdzlLj2KbA0phaJ0/es-ar?_r=AQABXe45mcGQp256mwxnogXyZaN3X8TPMhy8oauCA9MChHo&preview_theme_id=193700921425';
export function HeroSection() {
  return <section className="pt-24 pb-12 md:pt-32 md:pb-20 px-4" data-id="element-83">
      <div className="max-w-7xl mx-auto" data-id="element-84">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-85">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-86">
            <div className="mb-4" data-id="element-87">
              <span className="inline-block bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-semibold mb-4" data-id="element-88">
                Recetario ZERO: +500 Recetas Digitales
              </span>
            </div>

            <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl font-bold text-dark mb-6 leading-tight" data-id="element-89">
              Disfrutá postres, desayunos, comidas y cenas deliciosas sin
              sabotear tu alimentación
            </h1>

            <p className="text-lg md:text-xl text-dark/80 mb-8 leading-relaxed" data-id="element-90">
              Descubrí el recetario digital que ya ayudó a miles de personas a
              comer más rico, más liviano y con menos culpa, con +500 recetas
              fáciles, rápidas y pensadas para disfrutar sin azúcar y sin
              gluten.
            </p>

            <div className="flex flex-wrap gap-4 mb-8 text-sm md:text-base" data-id="element-91">
              <div className="flex items-center gap-2" data-id="element-92">
                <span className="text-yellow-500" data-id="element-93">⭐</span>
                <span className="font-semibold" data-id="element-94">
                  4.9/5 valorado por clientes felices
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-95">
                <span className="text-primary" data-id="element-96">✅</span>
                <span data-id="element-97">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-98">
                <span className="text-primary" data-id="element-99">✅</span>
                <span data-id="element-100">Formato digital compatible</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-101">
                <span className="text-primary" data-id="element-102">✅</span>
                <span data-id="element-103">Garantía de 7 días</span>
              </div>
            </div>

            <motion.a href={CART_LINK} className="inline-block w-full md:w-auto bg-accent hover:bg-accent/90 text-white font-bold text-lg px-8 py-4 rounded-lg shadow-lg transition-all duration-300 text-center" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} data-id="element-104">
              QUIERO ACCEDER AHORA
            </motion.a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-105">
            <img src="https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=800&h=800&fit=crop" alt="Recetas saludables" className="rounded-2xl shadow-2xl w-full h-auto" data-id="element-106" />
            <div className="absolute -bottom-4 -right-4 bg-white p-4 rounded-xl shadow-xl" data-id="element-107">
              <p className="font-playfair text-3xl font-bold text-primary" data-id="element-108">
                +500
              </p>
              <p className="text-sm text-dark/70" data-id="element-109">Recetas</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}